import { Gondor } from "../Gondor";

const ACTIONS = {
  FEATURE: "/feature/",
  FEATURE_ITEM: "/feature/{id}/",
  ADD_SYSTEMS: "/feature/add/system",
  REMOVE_SYSTEMS: "/feature/remove/system",
};

export function find(params?: object) {
  return Gondor.API.get(ACTIONS.FEATURE, { params });
}

export function findOne(id: number | string) {
  id = id.toString();
  return Gondor.API.get(ACTIONS.FEATURE_ITEM.replace("{id}", id));
}

export function create(body: object) {
  return Gondor.API.post(ACTIONS.FEATURE, body);
}

export function update(id: number | string, body: object) {
  id = id.toString();
  return Gondor.API.patch(ACTIONS.FEATURE_ITEM.replace("{id}", id), body);
}

export function destroy(id: number | string) {
  id = id.toString();
  return Gondor.API.delete(ACTIONS.FEATURE_ITEM.replace("{id}", id));
}

export function addSystems(body: object) {
  return Gondor.API.post(ACTIONS.ADD_SYSTEMS, body);
}

export function removeSystems(body: object) {
  return Gondor.API.post(ACTIONS.REMOVE_SYSTEMS, body);
}
